<template>
    <div>
        <div class="archiveContent">
            <!--
        <div v-if="!store.live && getList.length" class="topSeperator">Global Playlist</div>

        <div v-if="!store.live && getList.length" class="elementContainer" id="playlist">
            <Element v-for="(item, index) in getList" :live="store.live" :first="false" :key="item.id" :item="item" :index="index" :isArchive="false" :onArchive="true"></Element>
        </div>
        -->

            <div class="seperator">
                <img v-if="searchMag" id="searchImage" @click="searchClick" src="/static/new_icons/search_grey.svg"
                    alt="" />
                <img v-else id="searchImage" class="clear" @click="searchClick" src="/static/icons/clear-search.svg"
                    alt="" />

                <input ref="search" id="search" type="text" @keyup="search" v-model="searchParam"
                    placeholder="Search" />

                <div id="displaySwitch">
                    <img id="grid" @click="displayAsList = false" :src="!displayAsList || gridHover
                        ? 'static/new_icons/grid_active.svg'
                        : 'static/new_icons/grid.svg'
                        " @mouseover="gridHover = true" @mouseout="gridHover = false" />
                    <img id="list" @click="displayAsList = true" :src="displayAsList || listHover
                        ? 'static/new_icons/list_active.svg'
                        : 'static/new_icons/list.svg'
                        " @mouseover="listHover = true" @mouseout="listHover = false" />
                </div>

                <select id="" class="select-css" name="" v-model="sorter" @change="clickHead(sorter)">
                    <option value="start_time">Sort by Date</option>
                    <option value="artist">Sort by Artist</option>
                    <option value="title">Sort by Title</option>
                    <option value="venue">Sort by Venue</option>
                    <option value="city">Sort by City</option>
                </select>
                <span class="reverser arrow" v-if="reversed == true" @click="
                    setReverse();
                reorder();
                ">&uarr;</span><span v-else @click="
                    setReverse();
                reorder();
                " class="reverser arrow">&darr;</span>
            </div>

            <div id="archiveContainer" ref="archiveContainer">
                <div id="tags" ref="tags" :class="{ mobile: $mq == 'sm' }">
                    <!-- <span @click="selectTag('all')" class="tags visible" :class="{ -->
                    <!--     activeTag: store.selectedTags.length == 0, -->
                    <!-- }">All</span> -->
                    <img v-if="store.authenticated && (store.selectedTags.length == 0 && store.seriesVisible == false)"
                        :src="likeHover || store.selectedTags.includes('liked') ? '/static/Favorite_Hover.svg' : '/static/Favorite.svg'"
                        @mouseover="likeHover = true" @mouseout="likeHover = false" @click="selectTag('liked')"
                        class="visible button add" :class="{
                            activeTag: store.selectedTags.includes('liked'),
                        }" />
                    <img v-else-if="store.selectedTags.length > 0 || store.seriesVisible == true"
                        :src="closeTagHover ? '/static/new_icons/add_hover.svg' : '/static/icons/add.svg'"
                        @mouseover="closeTagHover = true" @mouseout="closeTagHover = false"
                        @click="selectTag('all'); closeTagHover = false; selectSeries('all'); store.seriesVisible = false"
                        class="visible button add closeTagHover" />
                    <span class="tags"
                        :class="{ availableTag: store.selectedTags.length == 0, activeTag: store.seriesVisible == true }"
                        @click="store.seriesVisible = true; selectTag('all')">All Series</span>
                    <template v-if="store.seriesVisible">
                        <template v-for="(series, index) in seriesList">
                            <span @click="selectSeries(series.slug)" class="tags availableTag"
                                :class="{ activeTag: store.selectedSeries.includes(series.slug) }">Series {{ index + 1
                                }}</span>
                        </template>
                    </template>
                    <template v-if="!store.seriesVisible">
                        <span v-for="tag in tags" @click="availableTags.includes(tag) ? selectTag(tag) : false"
                            class="tags" :class="{
                                activeTag: store.selectedTags.includes(tag),
                                availableTag: !store.selectedTags.includes('liked') && availableTags.includes(tag)
                            }" v-show="visibleTags.includes(tag)" v-html="upperFirst(tag)"></span>

                        <span @click="expandTags" id="expand" v-show="visibleTags.length != tags.length">&#xE011;</span>
                    </template>
                </div>

                <div v-if="searchParam" class="resultText">
                    {{ counter }} Search Results for “{{ searchParam }}”
                </div>
                <div v-else class="resultText">
                    {{ counter }} Shows
                </div>

                <div id="elementListContainer" v-if="list.length && displayAsList && $mq != 'sm'">
                    <div id="listHead">
                        <div class="function first"></div>
                        <div id="date" @click="clickHead('start_time')" :class="{ active: sorter == 'start_time' }">
                            Date<span v-if="
                                sorter == 'start_time' && reversed == true
                            " class="arrow">
                                &uarr;</span><span v-if="
                                    sorter == 'start_time' && reversed == false
                                " class="arrow">
                                &darr;</span>
                        </div>
                        <div id="artist" @click="clickHead('artist')" :class="{ active: sorter == 'artist' }">
                            Artist<span v-if="sorter == 'artist' && reversed == true" class="arrow">
                                &uarr;</span><span v-if="sorter == 'artist' && reversed == false" class="arrow">
                                &darr;</span>
                        </div>
                        <div id="title" @click="clickHead('title')" :class="{ active: sorter == 'title' }">
                            Title<span v-if="sorter == 'title' && reversed == true" class="arrow">
                                &uarr;</span><span v-if="sorter == 'title' && reversed == false" class="arrow">
                                &darr;</span>
                        </div>
                        <div id="venue" @click="clickHead('venue')" :class="{ active: sorter == 'venue' }">
                            Venue<span v-if="sorter == 'venue' && reversed == true" class="arrow">
                                &uarr;</span><span v-if="sorter == 'venue' && reversed == false" class="arrow">
                                &darr;</span>
                        </div>
                        <div id="city" @click="clickHead('city')" :class="{ active: sorter == 'city' }">
                            City<span v-if="sorter == 'city' && reversed == true" class="arrow">
                                &uarr;</span><span v-if="sorter == 'city' && reversed == false" class="arrow">
                                &darr;</span>
                        </div>
                        <div class="function last"></div>
                    </div>

                    <ListElement v-for="item in list" :live="store.live" :key="item.id" :item="item" :onArchive="true"
                        :first="false" :isArchive="true" :isPick="checkPick(item)"></ListElement>
                </div>
                <div class="elementContainer" v-else-if="list.length" id="archiveList" :class="{ mobile: $mq == 'sm' }">
                    <Element v-for="item in list" :live="store.live" :first="false" :key="item.id" :item="item"
                        :isArchive="true" :onArchive="true" :isPick="checkPick(item)"></Element>
                </div>

                <div v-else-if="firstLoad" class="resultText"></div>
                <!-- <div v-else class="resultText"> -->
                <!--     We could not find any results. Check the spelling or try -->
                <!--     different keywords. -->
                <!-- </div> -->

                <div v-show="showSpinner && list.length" id="scrollListener" ref="scrollListener">
                    <img id="spinner" src="/static/SpinnerBig.svg" alt="" />
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import { store } from "../store";
import axios from "axios";
import Element from "./Element";
import ListElement from "./ListElement";
import _ from "lodash";
import Footer from "./Footer.vue";
//import { EventBus  } from '../eventBus.js';

export default {
    name: "Archive",
    components: {
        Element,
        ListElement,
        Footer,
    },
    data() {
        return {
            store: store,
            list: [],
            fetchAllowed: true,
            showSpinner: true,
            fetchSequence: 0,
            fetchSorting: "-start_time",
            sorter: "start_time",
            reversed: true,
            searchParam: "",
            observer: null,
            counter: 0,
            firstLoad: true,
            searchMag: true,
            displayAsList: true,
            picks: [],
            gridHover: false,
            listHover: false,
            tags: [],
            visibleTags: [],
            widths: [],
            likeHover: false,
            availableTags: [],
            seriesList: [],
            closeTagHover: false,
        };
    },
    methods: {
        getSelectedTags() {
            if (this.store.selectedTags.length > 0) {
                return encodeURIComponent(this.store.selectedTags.join());
            } else {
                return "null";
            }
        },
        getSelectedSeries() {
            if (this.store.selectedSeries.length > 0) {
                return encodeURIComponent(this.store.selectedSeries.join());
            } else {
                return "null";
            }
        },
        getSearchParam() {
            if (this.searchParam != "") {
                this.searchMag = false;
                return this.searchParam;
            } else {
                this.searchMag = true;
                return "null";
            }
        },
        search() {
            //let myself = this;
            this.fetchSequence = 0;
            this.fetchAllowed = true;
            this.showSpinner = true;
            let url;
            // this.refs.archiveContainer.scrollTo(0, 0);
            this.$refs.archiveContainer.scrollTop = 0;
            // if (this.searchParam) {
            //this.$refs.search.style.backgroundImage = 'url(static/SearchClear.svg)';
            //this.$refs.searchImage.src = '/static/icons/clear-search.svg';
            this.searchMag = false;
            url =
                "/api/archive/" +
                this.store.userID +
                "/" +
                this.fetchSorting +
                "/" +
                this.fetchSequence +
                "/" +
                this.getSearchParam() +
                "/" +
                this.getSelectedTags() +
                "/" +
                this.getSelectedSeries();
            // } else {
            //this.$refs.search.style.backgroundImage = 'url(static/Search.svg)';
            //this.$refs.searchImage.src = '/static/Search.svg';
            // this.searchMag = true;
            // url =
            // "/api/archive/" +
            // this.fetchSorting +
            // "/" +
            // this.fetchSequence +
            // "/" +
            // this.getSelectedTags();
            // }
            axios.get(url).then((response) => {
                if (response.data.items.length > 0) {
                    this.list = response.data.items;
                } else {
                    this.list = [];
                }
                this.counter = response.data.count;
                this.availableTags = response.data.available_tags
            });
        },
        searchClick(el) {
            if (this.searchParam) {
                this.searchParam = "";
                //this.$refs.searchImage.src = '/static/Search.svg';
                this.searchMag = true;
                this.search();
            } else {
                this.$refs.search.focus();
            }
        },
        selectTag(tag) {
            this.store.selectedSeries = [];
            if (tag == "all") {
                this.store.selectedTags = [];
                this.visibleTags = this.tags;
                let myself = this
                setTimeout(function () {
                    myself.initTags()
                }, 200)
            } else if (tag == "liked") {
                if (this.store.selectedTags.includes('liked')) {
                    this.store.selectedTags = [];
                } else {
                    this.store.selectedTags = ['liked'];
                }
            } else if (this.store.selectedTags.includes(tag)) {
                let index = this.store.selectedTags.indexOf(tag);
                this.store.selectedTags.splice(index, 1);
            } else {
                if (this.store.selectedTags.includes('liked')) {
                    this.store.selectedTags = [tag];
                } else {
                    this.store.selectedTags.push(tag);
                }
            }
            this.search();
        },
        selectSeries(series) {
            this.store.selectedTags = [];
            if (series == "all") {
                this.store.selectedSeries = []
            } else {
                if (this.store.selectedSeries.includes(series)) {
                    let index = this.store.selectedSeries.indexOf(series);
                    this.store.selectedSeries.splice(index, 1);
                } else {
                    this.store.selectedSeries.push(series);
                }
            }

            this.search();
        },
        fetch() {
            let myself = this;
            let url;
            // if (this.searchParam) {
            //url = '/api/archive/' + this.fetchSorting + '/' + this.fetchSequence + '/' + this.searchParam
            url =
                "/api/archive/" +
                this.store.userID +
                "/" +
                this.fetchSorting +
                "/" +
                this.fetchSequence +
                "/" +
                this.getSearchParam() +
                "/" +
                this.getSelectedTags() +
                "/" +
                this.getSelectedSeries();
            // } else {
            //url = '/api/archive/' + this.fetchSorting + '/' + this.fetchSequence
            // url =
            // "/api/archive/" +
            // this.fetchSorting +
            // "/" +
            // this.fetchSequence +
            // "/" +
            // this.getSelectedTags();
            // }

            axios.get(url).then((response) => {
                if (response.data.items.length > 0) {
                    this.list = this.list.concat(response.data.items);
                    setTimeout(function () {
                        myself.fetchAllowed = true;
                        //setTimeout(function(){
                        //myself.observer.observe(myself.$refs.scrollListener)
                        //}, 500)
                    }, 500);
                } else {
                    //this.fetchAllowed = false;
                    this.showSpinner = false;
                }
            });
        },
        isScrolledIntoView(el) {
            let rect = el.getBoundingClientRect();
            let elemTop = rect.top;
            let elemBottom = rect.bottom;

            let isVisible = elemTop < window.innerHeight && elemBottom >= 0;
            return isVisible;
        },
        scroll() {
            // Handler falls kein Footer und damit window.onscroll noch frei.
            //window.onscroll = _.throttle(() => {
            //let scrolledTo = document.querySelector('#scrollListener')
            //if (scrolledTo && this.isScrolledIntoView(scrolledTo) && this.fetchAllowed) {
            //this.fetchSequence += 1
            //this.fetch()
            //this.fetchAllowed = false
            //}
            //}, 300)
        },
        clickReverser() {
            let myself = this;
            if (myself.fetchSorting.startsWith("-")) {
                myself.fetchSorting = myself.fetchSorting.replace("-", "");
                myself.reversed = true;
            } else {
                myself.fetchSorting = "-" + myself.fetchSorting;
                myself.reversed = false;
            }
            this.clickHead(this.sorter);
        },
        checkReverse(sorter) {
            let myself = this;
            let stripped;
            if (this.fetchSorting.startsWith("-")) {
                stripped = myself.fetchSorting.replace("-", "");
            } else {
                stripped = myself.fetchSorting;
            }
            if (sorter == stripped) {
                return true;
            } else {
                if (myself.sorter == "start_time") {
                    myself.reversed = true;
                } else {
                    myself.reversed = false;
                }
                return false;
            }
        },
        setReverse() {
            this.reversed = !this.reversed;
        },
        setFetchSorting() {
            let myself = this;
            if (myself.reversed) {
                myself.fetchSorting = "-" + myself.sorter;
            } else {
                myself.fetchSorting = myself.sorter;
            }
        },
        reorder() {
            this.setFetchSorting();
            this.search();
        },
        clickHead(sorter) {
            let myself = this;

            myself.sorter = sorter;

            if (myself.checkReverse(sorter) == true) {
                myself.setReverse();
            }
            myself.reorder();

            //let stripped = sorter;
            //if (this.fetchSorting.startsWith('-')){
            //stripped = sorter.replace('-', '')
            //}
            //if (this.fetchSorting == stripped){
            //if (this.reversed == true){
            //this.fetchSorting = stripped
            //this.reversed = false;
            //} else {
            //this.fetchSorting = '-' + sorter
            //this.reversed = true;
            //}
            //} else {
            //this.fetchSorting = sorter
            //this.reversed = false;
            //}
            //this.sorter = sorter
            //this.search()
        },
        checkPick(item) {
            if (this.picks.includes(item.pk)) {
                return true;
            } else {
                return false;
            }
        },
        checkTags() {
            let tagContainer = this.$refs.tags;
            let containerWidth = tagContainer.offsetWidth;
            let index = 0;
            let myself = this;
            for (let i = 0; i < myself.widths.length; i++) {
                if (containerWidth < myself.widths[i]) {
                    break;
                }
                index += 1;
            }
            this.visibleTags = this.tags.slice(0, index - 1);
        },
        expandTags() {
            this.visibleTags = this.tags;
        },
        upperFirst(tag) {
            return _.upperFirst(tag);
        },
        initTags() {
            let myself = this

            let tagContainer = myself.$refs.tags;

            //let tagList = tagContainer.querySelectorAll(":scope > .tags");
            let tagList = tagContainer.querySelectorAll(".tags");

            let tagWidth = 0;
            tagList.forEach((tag) => {
                // let marginWidth = window
                //     .getComputedStyle(tag)
                //     .getPropertyValue("margin-left")
                //     .match(/\d+/)[0];

                let width =
                    // tag.getBoundingClientRect().width + marginWidth * 2;
                    //tag.getBoundingClientRect().width + 15 + 6;
                    tag.getBoundingClientRect().width + 12;
                tagWidth += width;
                // myself.widths.push(tagWidth);
                myself.widths.push(tagWidth);
                myself.checkTags();
            });

        },
    },
    computed: {
        // getList() {
        //     if (this.store.live) {
        //         return this.store.liveList;
        //     } else {
        //         return this.store.playlist.slice(1);
        //     }
        // }
    },
    created() {
        //let myself = this;
        // Handler falls Footer und window.onscroll schon belegt.
        //EventBus.$on('footer', state => {
        //if (state == true && this.fetchAllowed) {
        //this.fetchSequence += 1
        //this.fetch()
        //this.fetchAllowed = false
        //}
        //} )
        let myself = this;
        this.observer = new IntersectionObserver(
            function (entries) {
                // isIntersecting is true when element and viewport are overlapping
                // isIntersecting is false when element and viewport don't overlap
                if (entries[0].isIntersecting == true && myself.fetchAllowed) {
                    setTimeout(function () {
                        myself.fetchSequence += 1;
                        myself.fetch();
                        myself.fetchAllowed = false;
                    }, 500);
                }
                //makeActive(entries[0].target.dataset.year)
            },
            { threshold: [0.5] }
        );

        //observer.observe(this.$refs.scrollListener);
    },
    mounted: function () {
        //this.scroll()
        let myself = this;
        setTimeout(function () {
            myself.observer.observe(myself.$refs.scrollListener);
        }, 1000);
        axios.get("/api/archive").then((response) => {
            this.firstLoad = false;
            this.tags = response.data.tags;
            this.seriesList = response.data.series_list;
            // this.tags = this.tags.concat(response.data.tags);
            // this.tags = this.tags.concat(response.data.tags);
            this.visibleTags = this.tags;
            setTimeout(function () {
                myself.initTags()
            }, 100);
        });
        this.search();
        axios.get("/api/get-picks").then((response) => {
            this.picks = response.data.items.map((i) => i.pk);
        });
        window.addEventListener("resize", _.throttle(this.checkTags, 100));
    },
    activated: function () {
        this.$refs.archiveContainer.scrollTop = this.store.archiveScrollPos;
        if (this.store.archiveTagChanged == true) {
            this.search();
            this.store.archiveTagChanged = false;
        }
    },
    beforeRouteLeave(to, from, next) {
        this.store.archiveScrollPos = this.$refs.archiveContainer.scrollTop;
        next();
    },
};
</script>

<style scoped>
#archiveContainer {
    overflow: scroll;
    flex-grow: 1;
}

.archiveContent {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

#scrollListener {
    width: 100%;
    height: 16rem;
    text-align: center;
}

.seperator {
    padding: 0.7rem 1rem 0.8rem;
    border-bottom: 1px solid black;
    /* width: calc(100% - 2rem); */
    display: flex;
    align-items: center;
    /* position: fixed; */
    background-color: white;
    /* z-index: 2; */
    gap: 1rem;
    /*
    border-bottom: 1px solid black;
    position: sticky;
    top: 3.3rem;
    */
}

/*
@media only screen and (min-width: 738px){
.seperator{
    top: 6.6rem;
}
}
*/
.seperator>span#title {
    flex-grow: 1;
}

.seperator>span {
    white-space: nowrap;
}

#sort {
    margin-right: 0.5rem;
}

#search {
    /*margin-right: 1rem;*/
    border: none;
    padding: 0;
    margin-top: 0;
    flex-grow: 1;
}

#search:focus {
    outline: none;
}

#search::placeholder {
    color: grey;
    opacity: 1;
}

#search:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: grey;
}

#search::-ms-input-placeholder {
    /* Microsoft Edge */
    color: grey;
}

@media only screen and (min-width: 738px) {
    #search {}
}

.topSeperator {
    padding: 0.7rem 1rem 0.8rem;
    width: calc(100% - 2rem);
    /*
    background-color: white;
    border-bottom: 1px solid black;
    position: sticky;
    top: 3.3rem;
    */
}

/*
@media only screen and (min-width: 738px){
.topSeperator{
    top: calc(6rem - 10px);
}
}
*/
.resultText {
    margin: 0.4rem 1rem -0.3rem;
}

@media only screen and (min-width: 738px) {
    .resultText {
        margin: 0.4rem 1rem 1rem;
    }
}

#archiveList {
    margin-bottom: 1rem;
}

#archiveList.mobile {
    grid-gap: 1rem;
}

.select-css {
    display: block;
    color: grey;
    font-family: "Montez Large";
    font-size: 1.333rem;
    box-sizing: border-box;
    margin: 0;
    border: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: #fff;
    cursor: pointer;
    outline: none;
    box-shadow: none;
    text-align: right;
    text-align-last: right;
    padding: 0;
}

@media only screen and (min-width: 738px) {

    .select-css,
    .reverser {
        display: none;
    }
}

.reverser {
    cursor: pointer;
    color: grey;
}

.select-css::-ms-expand {
    display: none;
}

.select-css:hover {
    border-color: black;
}

.select-css:focus {
    border-color: black;
    box-shadow: none;
    color: black;
    outline: none;
    font-weight: normal;
    font-family: "Montez Large";
    font-size: 1.333rem;
    padding-left: 0.5rem;
}

.select-css option {
    font-weight: normal;
    font-family: "Montez Large";
    font-size: 1.333rem;
}

#searchImage {
    height: 1.25rem;
    cursor: pointer;
    margin-top: 0.1rem;
}

#searchImage.clear {
    height: 0.8rem;
    margin-top: 0.3rem;
    margin-left: 0.45rem;
}

@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}

#spinner {
    animation: spin 1s linear infinite;
    margin: 7rem 1rem;
    max-width: 3rem;
}

#elementListContainer {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
}

#listHead {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid black;
    align-items: flex-start;
    height: 3.2rem;
    width: 100%;
    background-color: white;
}

#listHead>div:not(.function) {
    padding: 0.7rem 1rem 0.8rem;
    margin: 0;
    color: gray;
    cursor: pointer;
}

#listHead>div:not(.function):hover {
    color: black;
}

#listHead>div:not(.function).active {
    color: black;
}

div#date {
    /*flex-basis: 5%;*/
    flex-basis: 5.6rem;
}

div#artist {
    flex-basis: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-grow: 1;
    padding-left: 0 !important;
}

div#title {
    flex-basis: 30%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-grow: 1;
    padding-left: 0 !important;
}

div#venue {
    flex-basis: 12%;
    padding-left: 0 !important;
}

div#city {
    flex-basis: 12%;
    padding-left: 0 !important;
}

div#functions {
    padding: 0.7rem 1rem 0.8rem;
    flex-basis: 4.5rem;
    padding-left: 0 !important;
}

.function {
    flex-basis: 1.8rem;
    margin-right: 1rem;
}

.function.last {
    flex-basis: 3.7rem;
}

.function:first-child {
    margin-right: 0rem;
    margin-left: 1rem;
}

#displaySwitch {
    display: none;
}

@media only screen and (min-width: 738px) {
    #displaySwitch {
        display: block;
        display: flex;
        align-items: center;
    }
}

#displaySwitch>img {
    width: 2rem;
    margin-left: 1rem;
    cursor: pointer;
}

#tags {
    padding: 1rem 1rem 0.9rem;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
}

#tags.mobile {
    padding-bottom: 0;
}

#tags:not(.mobile)>span:hover {
    color: white;
    background-color: black;
}

.tags,
#expand {
    color: black;
    padding: 0rem 0.6rem;
    margin: 0rem;
    border: 1px solid black;
    border-radius: 2rem;
    font-size: 12px;
    /* visibility: hidden; */
    cursor: pointer;
    font-family: "Montez Small";
}

#expand {
    visibility: visible;
    color: grey;
    border: 1px solid grey;
}

#expand:hover {
    border: 1px solid black;
    color: black;
}

.tags {
    color: grey;
    border: 1px solid grey;
}

.tags.activeTag {
    color: white !important;
    background-color: black;
}

.tags.availableTag {
    color: black;
    border: 1px solid black;
}

.tags.visible {
    /* visibility: visible; */
}

.arrow {
    font-feature-settings: "ss02";
}

img.button.add {
    height: 1.7rem;
    cursor: pointer;
}

.closeTagHover {
    transform: rotate(45deg);
}
</style>
